import { render, staticRenderFns } from "./project-type-8.html?vue&type=template&id=b4ca09da&scoped=true&external"
import script from "./project-type-8.js?vue&type=script&lang=js&external"
export * from "./project-type-8.js?vue&type=script&lang=js&external"
import style0 from "./project-type-8.scss?vue&type=style&index=0&id=b4ca09da&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ca09da",
  null
  
)

export default component.exports